<template>

    <Body>
        <div class="body-wallet-address">
            <div class="text-15 text-gray text-center" v-html="lbl.init.checkWalletAddress"></div>
            <Divider class="divider1" />
            <div class="section-form">
                <div class="ff-semi text-15 label-wallet-addr text-center">
                    {{ lbl.init.enterWalletAddress }}
                </div>
                <div>
                    <InputTextarea v-model.trim="walletAddress" :maxLength="42" />
                    <div class="text-center my-4">Or</div>
                    <div class="text-center">
                        <label for="" class="bitkub-connect-label ff-semi text-15 block mb-2">Get Wallet Address from
                            Bitkub
                            NEXT</label>
                        <BitkubConnectButton @click="openBitkub()">Open Bitkub NEXT</BitkubConnectButton>
                        <div class="bitkub-howto">
                            <button class="w-full text-15 text-gray" type="button" @click="openHowTo()">
                                How to get wallet address ?
                            </button>
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <PrimaryButton @click="onClickContinue" :disabled="!isFormValid">
                        {{ lbl.buttons.continue }}
                    </PrimaryButton>
                </div>
            </div>
        </div>
    </Body>
</template>
<script>
import Util from "@/helper/Utility";
// component
import Body from "./Body.vue";
import Divider from "../Divider.vue";
import InputTextarea from "../Input/InputTextarea.vue";
import PrimaryButton from "../Button/PrimaryButton.vue";
import BitkubConnectButton from "../Button/BitkubConnectButton.vue"

// mixin
import ModalControllerMixin from "../../mixin/ModalControllerMixin";
import Plugins from "../../mixin/Plugins";

// service
import ConfigManager from "@/config/ConfigManager"
import { BitkubService } from "../../service/BitkubService";
import { Encrypt } from "@/core/Encrypt/Encrypt";
import { inject } from "vue";

// for test
//0xB83aae754c8D3848Fe0675A3E172C7005B09B11f

export default {
    name: "WalletAddress",
    components: {
        Body,
        Divider,
        InputTextarea,
        PrimaryButton,
        BitkubConnectButton,
    },
    props: {
        states: {
            type: Object
        }
    },
    inject: ["getQueryString"],
    mixins: [ModalControllerMixin, Plugins],
    emits: ["onContinue", "onInvalidWallet"],
    data: function () {
        return {
            walletAddress: "",
            bitKubService: new BitkubService(ConfigManager.getBitKubConfig())
        };
    },
    setup: function () {
        const { lbl } = inject("LocaleStore")

        return {
            lbl
        }
    },
    computed: {
        isFormValid: function () {
            if (this.walletAddress != null && this.validateCode()) {
                return true
            }
            return false
        }
    },
    mounted: function () {
        this.autoFillWalletAddress()
    },
    methods: {
        onClickContinue: function () {
            if (Util.isEmptyStr(this.walletAddress)) {
                return
            }

            if (!this.validateCode()) {
                this.modalController.alertModal
                    .clearModal()
                    .setTitle(this.lbl.errors.walletNotFound.title)
                    .setMsg(
                        Util.stringFormat(
                            this.lbl.errors.walletNotFound.message,
                            this.walletAddress.length > 12 ? this.maskWalletAddress(this.walletAddress) : this.walletAddress
                        )
                    )
                    .show();
                this.$emit("onInvalidWallet");
                return;
            } else {
                this.$emit("onContinue", this.walletAddress)
            }
        },
        validateCode: function () {
            var regex = /^0x[0-9A-Fa-f]{40}$/;

            // console.log(regex.test(this.walletAddress));
            if (regex.test(this.walletAddress)) {
                return true;
            }

            return false;
        },
        openBitkub: function () {
            const encryptor = new Encrypt()
            let bitkubConfig = ConfigManager.getBitKubConfig()
            // console.log(bitkubConfig)
            let returnUrl = bitkubConfig.redirectUri
            if (returnUrl.indexOf("devlandingvue") == -1) {
                returnUrl = `${window.location.origin}${returnUrl}`
            }
            let queryJson = JSON.parse(JSON.stringify(this.$route.query))
            delete queryJson.code // delete code if exists

            let stateJson = {
                module: "yescoin"
            }
            // console.log(Util.isEmptyStr(this.states.query.accessKey))
            if(Util.isEmptyStr(this.states.query.accessKey)){
                stateJson.data = encodeURIComponent(encryptor.encryptQueryString(JSON.stringify(queryJson), "bitkub"))
            }else{
                stateJson.accessKey = encodeURIComponent(encryptor.encryptQueryString(this.states.query.accessKey, "bitkub"))
            }
            let state = JSON.stringify(stateJson)
            let authUri = `${bitkubConfig.endpoint}/oauth2/authorize?response_type=code&client_id=${bitkubConfig.clientId}&redirect_uri=${returnUrl}&state=${state}`

            // window.location.replace(authUri)
            sessionStorage.setItem("bzbs.state", state)
            window.location.href = authUri
            console.log(authUri)
        },
        openHowTo: function () {
            this.modalController.howToModal.show()
        },
        autoFillWalletAddress: function () {
            // this.modalController.loadingModal.show()
            let authCode = this.$route.query.code || ""
            let refreshToken = this.bitKubService.refreshToken()
            if (!Util.isEmptyStr(authCode) || !Util.isEmptyStr(refreshToken)) {
                this.bitKubService.getAccessToken(authCode).then((accessToken) => {
                    this.getBitkubProfile(accessToken)
                }).catch((err) => {
                    console.log(err);
                    // try refresh access token
                    this.bitKubService.refreshAccessToken().then((accessToken) => {
                        // console.log("refresh", accessToken)
                        this.getBitkubProfile(accessToken)
                    }).catch(err2 => {
                        console.log(err2)
                        // show error can not get access token
                    })
                }).finally(() => {
                    // this.modalController.loadingModal.hide()
                })
            }
        },
        getBitkubProfile: function (accessToken) {
            this.bitKubService.getAccount(accessToken).then((resp) => {
                // console.log(resp)
                if (resp.ok) {
                    this.walletAddress = resp.data.wallet_address
                    // console.log("set wallet address", this.walletAddress)
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../style/base.scss";

.body-wallet-address {
    @extend %base-class;
    color: $gray;

    .section-form {
        .label-wallet-addr {
            margin-bottom: 12px;
        }
    }

    .divider1 {
        margin-top: 20px;
        margin-bottom: 30px;
    }

    .text-gray {
        color: $gray;
    }

    .bitkub-connect-label {
        color: #27d87d;
    }

    .bitkub-howto {
        margin: 40px 0px;

        button {
            text-decoration: underline;
            background: none;
            outline: none;
            -webkit-appearance: none;
            border: none;
        }
    }
}
</style>
